class audienceChecker {
  constructor(opts) {
    this.checkUrl = opts.check_url;
    this.ready  = false;
    this.progressBar = $(".progress-bar")

    this.pollForReady();
    this.updateProgressBar(0);
  }

  pollForReady() {
    setInterval(() => {
      if (!this.ready) {
        this.poll()
      }
    }, 2000);
  }

  poll() {
    var self = this;
    $.getJSON(this.checkUrl, function(data) {
      self.updateProgressBar(data.progress);
      if (data.ready) {
        self.ready = true
        window.location.reload();
      }
    });
  }

  updateProgressBar(amount) {
    if (amount < 0.05) {
      amount = 0.05;
    }

    this.progressBar.width(parseInt(amount * 100) + '%')
  }
}

if (window.emailAudienceCheckerOptions) {
  window.audienceChecker = new audienceChecker(window.emailAudienceCheckerOptions);
}

export default audienceChecker;



// WEBPACK FOOTER //
// app/client/bundles/EmailCampaign/audienceChecker.js